import { Component } from '@angular/core';

import { CamIconType, FontIconComponent, LocalIconComponent, MaterialIconComponent } from '@camelot/icons';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [FontIconComponent, LocalIconComponent, MaterialIconComponent, TestIdDirective],
    template: `
    <cam-font-icon camTestId="cam-font-icon" name="edit" />
    <cam-local-icon camTestId="cam-local-icon" [type]="this.localIcon" />
    <cam-material-icon camTestId="cam-material-icon">home</cam-material-icon>
  `
})
export class IconsCase {
  public localIcon = CamIconType.Add;
}
